import React, { useContext, useEffect } from "react";
import AuthContext from "../Auth/AuthContext";
import { useTour } from "./TourContext";
import { SKIP_FLAG } from "./TourEngine";
import { GETTING_STARTED_KEY } from "./tourRegistry";

// Auto-start the getting-started tour for users who haven't completed it
// yet, unless they've already skipped it this browser session.
// Lives inside TourProvider so it can call startTour().
export default function TourAutoStarter() {
  const { authUser } = useContext(AuthContext);
  const { startTour } = useTour();
  useEffect(() => {
    if (!authUser) return;
    if (authUser.tutorial_completed_at) return;
    try {
      if (sessionStorage.getItem(SKIP_FLAG)) return;
    } catch (_) {}
    // Defer slightly so the layout/sidebar are in the DOM before the first
    // step tries to target them.
    const t = setTimeout(() => startTour(GETTING_STARTED_KEY), 600);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUser?.id]);
  return null;
}
